<template>
  <div
    ref="dropdownContainer"
    class="combo-dropdown-panel"
    :style="dropdownStyles"
  >
    <div
      v-if="!loading"
      ref="menuBodyCon"
      class="dropdown-body-container scroller-overlay"
      :style="dropdownBodyStyle"
      @scroll.stop="onDropdownMenuScroll"
    >
      <!-- Phần header của menu khi có grid-->
      <table
        v-if="columnx && columnx.length > 0"
        class="dropdown-table"
        :style="headerStyle"
      >
        <thead class="dropdown-header">
          <tr>
            <th
              v-if="isCheckMultiple"
              class="dropdown-header__th"
            />
            <th
              v-for="(column, index) in columnx"
              :key="index"
              class="dropdown-header__th"
              :title="column.tooltip"
              :style="getThStyle(column)"
            >
              <!-- Add by ĐVThi fix lỗi căn trái không thẳng hàng tiêu đề cột với dữ liệu phía dưới -->
              <span>{{ column.title }}</span>
            </th>
          </tr>
        </thead>
        <tbody class="dropdown-items">
          <slot />
        </tbody>
      </table>
      <ul
        v-else-if="comboType === 1"
        class="dropdown-items"
      >
        <slot />
      </ul>
      <!-- Phần nội dung grid combo có columns và combo tree -->
      <table
        v-else
        class="dropdown-table"
      >
        <tbody class="dropdown-items">
          <slot />
        </tbody>
      </table>
    </div>
    <!-- <slot name="quickSearch" /> -->

    <!-- Hiển thị loading khi chưa có dữ liệu -->
    <div
      v-if="loading"
      class="dropdown--loading"
    >
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <!-- Show thông báo khi không có dữ liệu hiển thị -->
    <div
      v-else-if="showEmptyText"
      class="no-data-display"
    >
      <div class="no-data-display__text">
        {{ $t('i18nComponent.Combobox.DataEmpty') }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  getCurrentInstance,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue'

import { ComboType } from './constants'

const SCROLL_BOTTOM_IS_END = 3

export default defineComponent({
  name: 'MsComboBoxDropdown',
  props: {
    /**
     * Loại combo
     */
    comboType: {
      type: Number,
      default: ComboType.Normal,
    },
    /**
     * Số lượng item hiển thị ở dropdown
     */
    maxItemsDisplay: {
      type: Number,
      default: 5,
    },
    /**
     * Các cột của dropdown
     */
    columnx: {
      type: Array,
      default: () => [],
    },
    /**
     * Trạng thái `loading`
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Độ rộng phần dropdown, nếu bằng <=0 hoặc Auto sẽ tự động tính toán
     */
    dropdownWidth: {
      type: [Number, String],
      default: 0,
    },
    /**
     * Có hiển thị empty text không
     */
    showEmptyText: {
      type: Boolean,
      default: false,
    },
    /**
     * style top cho dropdown
     */
    topx: {
      type: Number,
      default: null,
    },
    /**
     * style left cho dropdown
     */
    leftx: {
      type: Number,
      default: null,
    },
    /**
     * style max-with cho dropdown
     */
    maxWidthx: {
      type: Number,
      default: null,
    },
    /**
     * style min-with cho dropdown
     */
    minWidthx: {
      type: Number,
      default: null,
    },
    /**
     * vị trí bản ghi được chọn trước đó
     */
    highlighIndex: {
      type: Number,
      default: null,
    },
    /**
     * vị trí scroll cũ
     */
    scrollTop: {
      type: Number,
      default: 0,
    },
    /**
     * được dùng trong grid
     */
    isGridEditor: {
      type: Boolean,
      default: false,
    },
    /**
     * Show check box selected
     */
    isCheckMultiple: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['scrollend', 'addNew', 'update:scrollTop'],
  setup (props, { emit }) {
    // Variable
    let containerWidth = 0
    const { proxy } = getCurrentInstance()
    const menuBodyCon = ref()
    const dropdownContainer = ref()

    // Method
    /**
     * Hàm lấy style cho th trong table
     * dữ liệu động theo config của dev
     */
    const getThStyle = (column) => {
      return {
        width: column.isResize ? null : `${column.width}px`,
        textAlign: column.columnAlign,
      }
    }

    /**
     * Xử lý sự kiện click bất kỳ đâu trên document
     */
    // const onDocumentClick = (event) => {
    //   const targetCombo = event.target.closest('.ms-combo'),
    //     comboEl = proxy.$parent.$el;

    //   if (targetCombo !== comboEl) {
    //     proxy.$parent.collapse();
    //   }
    // };

    /**
     * Sự kiện khi scroll dropdown menu
     */
    const onDropdownMenuScroll = (e) => {
      const target = e.target
      // kiểm tra nếu scroll to bottom -> emit để combobox load thêm dữ liệu
      if (target.scrollTop >= target.scrollHeight - target.offsetHeight - SCROLL_BOTTOM_IS_END) {
        emit('scrollend')
      }

      proxy._scrollTop = target.scrollTop
    }

    /**
     * Xử lý sự kiện scroll document
     * - Đóng menu
     */
    const onDocumentScroll = (event) => {
      const comboMenu = event.target.closest('.combo-dropdown-panel')
      if (!comboMenu || comboMenu !== proxy.$el) {
        // thêm kiểm tra để sửa lỗi khi combobox.innerText dài quá sẽ không expand dc
        if (
          event.target &&
          proxy.$parent &&
          proxy.$parent.$refs.input &&
          event.target === proxy.$parent.$refs.input
        ) {
          return
        }

        proxy.$parent.collapse()
      }
    }

    const onWindowResize = () => {
      proxy.$parent?.collapse()
    }

    /**
     * Hàm append dropdown menu vào thẻ body
     * append vào trước phần tử đầu tiên trong thẻ body
     */
    const insertBody = () => {
      document.body.insertBefore(proxy.$el, document.body.firstChild)
    }

    /**
     * Thêm mới
     */
    const addNewClick = () => {
      emit('addNew')
    }

    // Hooks
    const headerStyle = computed(() => {
      return {
        // width: this.headerWidth + "px"
      }
    })

    const headerWidth = computed(() => {
      let width = 0
      if (containerWidth) {
        width = containerWidth
      } else if (props.columnx && props.columnx.length > 0) {
        for (let index = 0; index < props.columnx.length; index++) {
          const element = props.columnx[index]
          if (element.width) {
            width = width + element.width
          }
        }
      }
      return width
    })

    const dropdownStyles = computed(() => {
      const width = headerWidth
      const docWidth = document.body.clientWidth
      let left = props.leftx
      if (left + width + props.dropdownWidth > docWidth) {
        left = left - (width + left + props.dropdownWidth - docWidth)
      }

      const res = {
        top: props.topx + 'px',
        // left: left + "px",
        minWidth: props.minWidthx + 'px',
        maxWidth: props.maxWidthx + 'px',
      }

      if (left + width >= docWidth) {
        res.right = '10px'
      } else {
        res.left = left + 'px'
      }

      return res
    })
    /**
     * Set lại chiều cao tối đa của dropdown nếu số lượng item hiển thị khác default
     */
    const dropdownBodyStyle = computed(() => {
      let style = {}
      if (props.maxItemsDisplay !== 5) {
        style = {
          maxHeight: `${props.maxItemsDisplay * 36}px`,
        }
      }

      return style
    })

    onMounted(() => {
      // Append menu vào thẻ body
      insertBody()
      // Thêm event click vào document
      // document.addEventListener('click', me.onDocumentClick);

      document.addEventListener('scroll', onDocumentScroll)

      window.addEventListener('resize', onWindowResize)

      // highlight
      if (props.scrollTop > 0 && menuBodyCon.value) {
        menuBodyCon.value.scrollTop = props.scrollTop
      } else if (props.highlighIndex > -1) {
        const row = proxy.$el.querySelector('tr.combobox-item')
        if (row) {
          const rowHeight = row.getBoundingClientRect().height
          const top = props.highlighIndex * Number.parseInt(rowHeight)
          menuBodyCon.value.scrollTop = top
        }
      }

      nextTick(() => {
        if (dropdownContainer.value) {
          containerWidth = dropdownContainer.value.clientWidth
        }
      })
    })

    onBeforeUnmount(() => {
      document.removeEventListener('scroll', onDocumentScroll, true)

      window.removeEventListener('resize', onWindowResize)

      emit('update:scrollTop', proxy._scrollTop)
    })

    return {
      menuBodyCon,
      dropdownContainer,
      headerStyle,
      headerWidth,
      dropdownStyles,
      dropdownBodyStyle,
      addNewClick,
      getThStyle,
      // onDocumentClick,
      onDropdownMenuScroll,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsComboboxDropdown.scss';
</style>
